import React from 'react'

export default function SectionHeader({ children, icon, style = {}, titleStyle = {} }) {
  const styles = {
    container: {
      display: 'flex',
      paddingBottom: 10,
      textTransform: 'uppercase',
      borderBottom: '1px solid #14B0BF',
      color: '#14B0BF',
    },
    icon: {
      width: 30,
    },
    title: {
      paddingLeft: 10,
      fontSize: 12,
      fontWeight: 300,
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }
  return (
    <header style={{ ...styles.container, ...style }}>
      {icon ? <div style={{ ...styles.icon, ...styles.center }}>{icon}</div> : null}
      <div style={{ ...styles.title, ...styles.center, ...titleStyle }}>{children}</div>
    </header>
  )
}
